import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ModalTypes, RenderTypes } from '../../Constants';
import Styles from './Study.cssmodule.less';
import Render from '../Render';
import { PrebuiltHintData } from '../../static';
import Util from '../../utils/util';
import { updateCommonData, RELOAD_ENTRY } from '../../actions';
import { bindActionCreators } from 'redux';

const MissionIntro = (props) => {
    const view = Entry.createElement('div');
    const renderView = new Render({
        target: view,
        data: {
            type: RenderTypes.MISSION_INTRO,
            content: props,
        },
    });
    renderView.on('click', props.onClickHandler);
    return view;
};

class CurriculumStudy extends Component {
    constructor(props) {
        super(props);
        this.missionPopup = new entrylms.Modal();
        this.completePopup = new entrylms.Modal();
        this.runEventFunc = this.runEventFunc.bind(this);
        this.stopEventFunc = this.stopEventFunc.bind(this);
        this.container = null;
        this.score = {};
    }

    /* Lifecycle Events */
    componentDidMount() {
        const data = { ...this.props.data, ...this.props.data.contents };

        entrylms.off('registerScore');
        entrylms.on(
            'registerScore',
            function(data) {
                this.score = Object.assign(this.score, data);
            }.bind(this)
        );

        this.completePopup.on('show', () => {
            Entry.engine.closeFullScreen();
            Entry.engine.toggleStop();
            Entry.stage.updateBoundRect();
        });

        this.completePopup.on('hide', () => {
            if (Entry.engineContainer) {
                Entry.engineContainer.insertBefore(
                    Entry.engine.view_,
                    Entry.engineContainer.firstChild
                );
            } else {
                Entry.view_.insertBefore(
                    Entry.engine.view_,
                    Entry.container.view_
                );
            }
            Entry.stage.updateBoundRect();
        });

        this.completePopup.on('click', (type) => {

            Entry.engine.toggleStop();
            let submitType = '';
            if (type === 'next') {
                // INFO : 완료 액션
                submitType = 'ExitStudy';
            } else if (type === 'submit') {
                submitType = 'SubmitStudy';
            } else {
                // INFO: 이곳이 팝업에서 이전 클릭 했을때 반응
                return;
            }
            console.log('clicked', type, submitType);
            entrylms.emit('saveWorkspace', (projectId) => {
                var emitValue = { category: 'mission' };
                if (!_.isEmpty(this.score))
                    emitValue.value = { score: this.score };
                entrylms.emit(submitType, emitValue);
            });
        });

        this.missionPopup.on('click', (...args) => {
            entrylms.emit('click.popup', args);
        });

        this.popupView = $('<div>');
        this.renderView = new Render({
            target: this.popupView,
        });

        this.renderView.on('click', (e, data = {}) => {
            console.log(data);
            const { contents } = this.props.data.contents;
            if (data.type === 'default') {
                this.missionPopup.modalData = {
                    type: 'MANUAL',
                    content: 'MISSION',
                };
            } else if (data.type === 'intro') {
                this.showIntroPopup(this.props.data);
                return;
            } else if (data.type === 'hint') {
                const items = contents[data.value].items;
                this.missionPopup.modalData = items.map((item) => {
                    item.type = ModalTypes.HINT;
                    item.title = item.title || contents[data.value].title || '';
                    return item;
                });
            } else {
                const items = contents[data.value].items;
                this.missionPopup.modalData = PrebuiltHintData[items.content];
            }

            this.missionPopup.itemIndex = 0;
            this.missionPopup.show();
        });
        var device =
            window.platform && window.platform.type ? 'tablet' : null;
        this.initOption = {
            type: 'workspace',
            fonts: EntryStatic.fonts,
            libDir: '/lib',
            device: device,
            loadInterface: true,
            doCommandAll: false,
            commentDisable: true,
            backpackDisable: true,
        };

        Object.assign(this.initOption, data.injectOption);

        if (Entry.type && Entry.type != 'invisible') {
            Entry.changeContainer(this.container);
            Entry.reloadOption(this.initOption);
        } else {
            Entry.init(this.container, this.initOption);
        }

        const container = $(this.container);

        if (!Entry.objectEditable) container.addClass(Styles.objectNotEditable);
        else container.removeClass(Styles.objectNotEditable);

        container.addClass(Styles.variableNotEditable);
        container.addClass(Styles.messageNotEditable);
        container.addClass(Styles.listNotEditable);
        container.addClass(Styles.functionNotEditable);

        if (data.injectOption && data.injectOption.freezingVariable) {
            container.addClass(Styles.freezingVariable);
        } else {
            container.removeClass(Styles.freezingVariable);
        }

        Entry.propertyPanel.select('object');
        //Entry.addEventListener('run', this.runEventFunc);
        //Entry.addEventListener('stop', this.stopEventFunc);
        Entry.engine.attachKeyboardCapture();
        $('body').css('overflow', 'hidden');
        this.loadData(data);
    }

    componentDidUpdate(prevProps) {
        const data = { ...this.props.data, ...this.props.data.contents };
        const previousId = prevProps.data ? prevProps.data._id : '';
        const isReloadAction = !prevProps.common.reload && this.props.common.reload;
        //reloadEntry
        if(isReloadAction) {
            this.reloadEntry();
            this.props.actions.updateCommonData(RELOAD_ENTRY, false);
            return ;
        }

        if (previousId !== data._id || data.isNew) {
            if (this.props.data.injectOption) {
                Entry.reloadOption({ commentDisable: true, backpackDisable: true, ...data.injectOption });
            }
            this.loadData(data);
        }


    }

    reloadEntry = () => {
        const temp = Entry.exportProject();
        Entry.clearProject();
        Entry.disposeContainer();
        Entry.reloadBlock();
        Entry.init(this.container, this.initOption);
        entrylms.emit('reloadWorkspace', temp);
    };

    componentWillUnmount() {
        //Entry.removeEventListener('run', this.runEventFunc);
        //Entry.removeEventListener('stop', this.stopEventFunc);
        Entry.propertyPanel.removeMode('goal');
        Entry.propertyPanel.removeMode('hint');
        entrylms.off('registerScore');
        this.score = {};

        const container = $(this.container);

        container.removeClass(Styles.objectNotEditable);
        container.removeClass(Styles.freezingVariable);
        container.removeClass(Styles.variableNotEditable);
        container.removeClass(Styles.messageNotEditable);
        container.removeClass(Styles.listNotEditable);
        container.removeClass(Styles.functionNotEditable);
    }

    loadData(data) {
        const { basicProject } = data;
        const { contents = {} } = data;
        if (!basicProject) return;

        // if (doneProject && (!injectOption || !injectOption.hintDisable)) {
        //     Entry.propertyPanel.removeMode('goal');
        //     const donepr = new Entry.DoneProject(doneProject._id);
        //     Entry.propertyPanel.addMode('goal', donepr);
        // }

        Entry.clearProject();
        this.setAvailableBlocks(data);

        if (!Entry.objectEditable)
            basicProject.objects.forEach((o) => (o.lock = true));
        if (data.isNew && data.injectOption.lockBasicBlocks)
            this.lockDefaultBlocks(basicProject);

        Entry.loadProject(basicProject);
        Entry.scene.selectScene();
        //checkScript
        Entry.container.addExtension(
            new Entry.TargetChecker(data.checkScript, false, "curriculum_study")
        );
        Entry.targetChecker.statusViewDisabled = true;
        Entry.achieveEvent.attach(this, this.checkAchieve);
        this.showIntroPopup(data);

        if (!Entry.objectEditable)
            Entry.container.mapObject((o) => o.disableContextMenu);

        if (this.renderView) {
            this.renderView.renderData = {
                type: 'POPUP_LIST',
                content: contents.contents,
            };
        }
        if (contents && contents.question) {
            const question = data.question || contents.question || '';
            Entry.intro.removeView();
            Entry.intro.setView(
                new MissionIntro({
                    text: question,
                    image: "/img/assets/course/img_mission_icon.png",
                    type: data.type,
                    btnText: data.type === "mission" ? "잘 모르겠어요!": "학습 완료하기",
                    onClickHandler: (e, data) => {
                        switch(data.type) {
                            case "free":
                                this.completePopup.modalData = [
                                    {
                                        type: ModalTypes.CURRICULUM_STUDY_COMPLETE,
                                        contentType: 'DONE', // DONE, FAIL, SUCCESS
                                    },
                                ];
                                this.completePopup.itemIndex = 0;
                                this.completePopup.show();
                                break;
                            case "mission":
                            default:
                                if (!contents.hints) {
                                    return;
                                }
                                this.missionPopup.modalData = contents.hints.map(
                                    (item) => {
                                        item.type = ModalTypes.CURRICULUM_HINT;
                                        item.title = item.name || '';
                                        return item;
                                    }
                                );
                                this.missionPopup.itemIndex = 0;
                                this.missionPopup.show();
                                break;
                        }

                    },
                })
            );
        }
    }

    setAvailableBlocks(data) {
        if (!data) return;
        $(".entryCategoryListWorkspace").remove();
        var { availableBlocks: blockJSON } = data;
        const blockMenu = Entry.getMainWS().blockMenu;
        blockMenu.setNoCategoryData(Util.generateBlocks(blockJSON));
        Util.unbanHW();
        blockMenu.disableMouseEvent = false;
    }
    /* Events Handler */

    /* User Function*/
    showIntroPopup(data) {
        if (!data || !data.contents) {
            return;
        }
        const { contents: dataContents } = data.contents;
        if (data && dataContents && dataContents.length) {
            const contents = dataContents.filter((c) => {
                return c;
            });
            contents.map((content) => {
                if (!content || content.type !== 'intro') return;
                this.missionPopup.modalData = content.items.map((item) => {
                    item.type = ModalTypes.INTRO;
                    item.title = item.title || data.parentTitle || '';
                    return item;
                });
                this.missionPopup.itemIndex = 0;
                this.missionPopup.show();
            });
        }
    }

    checkAchieve(result, message) {
        if (this.completePopup.isShowing()) {
            return;
        }
        const { data } = this.props;
        switch (result) {
            case 'success':
                this.completePopup.modalData = [
                    {
                        type: ModalTypes.CURRICULUM_STUDY_COMPLETE,
                        contentType: 'SUCCESS', // DONE, FAIL, SUCCESS
                    },
                ];
                this.completePopup.itemIndex = 0;
                this.completePopup.show();
                break;
            case 'fail':
                this.completePopup.modalData = [
                    {
                        type: ModalTypes.CURRICULUM_STUDY_COMPLETE,
                        contentType: 'FAIL', // DONE, FAIL, SUCCESS
                        message
                    },
                ];
                this.completePopup.itemIndex = 0;
                this.completePopup.show();
                break;
        }
    }

    lockDefaultBlocks(basicProject) {
        function lockThread(thread) {
            thread.map(function(b) {
                b.emphasized = true;
                if (b.params) {
                    for (var i in b.params) {
                        var param = b.params[i];
                        if (param && param.type) lockThread([param]);
                    }
                }
                if (b.statements) {
                    for (var key in b.statements) lockThread(b.statements[key]);
                }
            });
        }

        basicProject.objects.map(function(o) {
            var scriptJSON = JSON.parse(o.script);
            scriptJSON.map(lockThread);
            o.script = JSON.stringify(scriptJSON);
        });
    }

    runEventFunc() {
        if (!Entry.engine.popup && !this.completePopup.isShowing())
            Entry.engine.toggleFullScreen();
    }

    stopEventFunc() {
        if (Entry.engine.popup && !this.completePopup.isShowing())
            Entry.engine.closeFullScreen();
        $('body').css('overflow', 'hidden');
    }

    render() {
        return (
            <div
                id={Styles.missionComponent}
                className={Styles.wsComponent}
                ref={(div) => {
                    this.container = div;
                }}
            />
        );
    }
}

CurriculumStudy.displayName = 'CurriculumStudy';
CurriculumStudy.defaultProps = {
    data: {
        title: '',
        isHomework: false,
        isHomeworkLapse: false,
        isLastStudy: false,
    },
};

const mapStateToProps = (state) => ({
    ...state,
});

function mapDispatchToProps(dispatch) {
    const actions = { updateCommonData };
    return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CurriculumStudy);



// WEBPACK FOOTER //
// ./components/Curriculum/Study.js